export default __webpack_public_path__ + "static/1.1-126da78e3f5b0f7d92c1044ab608736f.webp";